/**
 * @generated SignedSource<<8f84144563d14041b5a0edb9186f3562>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type salesChannelActiveFragmentQuery$variables = Record<PropertyKey, never>;
export type salesChannelActiveFragmentQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"salesChannelsActive">;
};
export type salesChannelActiveFragmentQuery = {
  response: salesChannelActiveFragmentQuery$data;
  variables: salesChannelActiveFragmentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "taskID",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "salesChannelActiveFragmentQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "salesChannelsActive"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "salesChannelActiveFragmentQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserInfo",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userID",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "status",
            "value": "ACTIVE"
          }
        ],
        "concreteType": "SalesChannel",
        "kind": "LinkedField",
        "name": "salesChannels",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SalesChannelDetail",
            "kind": "LinkedField",
            "name": "detail",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SalesChannelDetailProperties",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EcommerceSettings",
            "kind": "LinkedField",
            "name": "ecommerceSettings",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ecommerceGlobalID",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ecommerceName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "remoteUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isMarketplace",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "definitiveUrl",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "salesChannels(status:\"ACTIVE\")"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProductSwitcherTask",
        "kind": "LinkedField",
        "name": "productSwitcherTasks",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "taskType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastError",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "elapsedTime",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "modifiedOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProductSwitcherTaskExtraData",
            "kind": "LinkedField",
            "name": "extraData",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "masterSalesChannelID",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "secondarySalesChannelID",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "delayMinutes",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isSellerMigrating",
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d5d4553d5ebf7543217bf6deb024df32",
    "id": null,
    "metadata": {},
    "name": "salesChannelActiveFragmentQuery",
    "operationKind": "query",
    "text": "query salesChannelActiveFragmentQuery {\n  ...salesChannelsActive\n}\n\nfragment salesChannelsActive on Query {\n  user {\n    userID\n    email\n    id\n  }\n  salesChannels(status: ACTIVE) {\n    id\n    detail {\n      id\n      properties {\n        name\n      }\n    }\n    ecommerceSettings {\n      id\n      ecommerceGlobalID\n      ecommerceName\n      remoteUrl\n      isMarketplace\n      definitiveUrl\n    }\n  }\n  productSwitcherTasks {\n    taskID\n    state\n    taskType\n    lastError\n    elapsedTime\n    modifiedOn\n    extraData {\n      taskID\n      masterSalesChannelID\n      secondarySalesChannelID\n      delayMinutes\n    }\n    id\n  }\n  isSellerMigrating\n}\n"
  }
};
})();

(node as any).hash = "b4b973904533f9298052cb004804b38c";

export default node;
